import React from 'react';
import { Dialog, DialogContent, Box } from '@mui/material';
import { Button } from '../../../components/Button/button';
import { region } from '../../../config/images';

const ImportExcelPopup = ({
  open,
  onClose,
  selectedFile,
  handleFileChange,
  handleImportExcel,
  loading,
  translations,
  language
}) => {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      disableScrollLock
      PaperProps={{
        sx: { borderRadius: "12px" },
      }}
    >
      <div className="assign-div">
        <div className="d-flex justify-content-around align-items-center">
          <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
            {translations[language].importExcel}
          </h5>
        </div>
      </div>
      <DialogContent>
        <Box textAlign="center">
          <input
            type="file"
            accept=".xlsx, .xls"
            id="file-upload"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          <label htmlFor="file-upload">
            <Box
              sx={{
                width: "390px",
                height: "150px",
                border: "2px dashed #3C4856",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                overflow: "hidden",
                backgroundColor: "#fff",
                boxShadow: "0px 4px 10px rgba(160, 160, 160, 0.16)",
              }}
            >
              {selectedFile ? (
                <Box textAlign="center">
                  <img
                    src={region.browseImage}
                    alt="Excel"
                    style={{ width: 50, height: 50, marginBottom: 8 }}
                  />
                  <Box sx={{ fontSize: "14px", fontWeight: 500 }}>
                    {selectedFile.name}
                  </Box>
                  <Box sx={{ fontSize: "12px", color: "#555" }}>
                    {(selectedFile.size / 1024).toFixed(1)} KB
                  </Box>
                </Box>
              ) : (
                <img src={region.browseImage} alt="" />
              )}
            </Box>
          </label>
          <div className="d-flex gap-3 mt-4">
            <button
              className="cancel-button"
              onClick={onClose}
            >
              {translations[language].cancel}
            </button>
            <Button
              title={translations[language].importExcel}
              classname={"assign-task-button"}
              onClick={handleImportExcel}
              loading={loading}
            />
          </div>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ImportExcelPopup;